import {initCarousels} from "./utils/carousel";

$(function() {
    initCarousels()
})